export default __webpack_public_path__ + "static/media/ThinkLogistics.19d0556af22a794a50d88af94b7197f4.webp";